import { useMemo } from 'react';
import { Button, Chip, TableCell, TableRow } from '@mui/material';

export type TaskStatus = 'Incomplete' | 'Complete';

const TASK_BUTTON_SX = {
  textTransform: 'none',
  fontWeight: 600,
  borderRadius: 2,
  minWidth: 120,
} as const;

export function StatusChip({ status }: { status: TaskStatus }) {
  const { color, variant } = useMemo(() => {
    switch (status) {
      case 'Incomplete':
        return { color: 'warning' as const, variant: 'filled' as const };
      default:
        return { color: 'default' as const, variant: 'outlined' as const };
    }
  }, [status]);

  return <Chip size="small" label={status} color={color} variant={variant} />;
}

export function EventFormActionButton({
  status,
  onComplete,
  onView,
}: {
  status: TaskStatus;
  onComplete?: () => void;
  onView?: () => void;
}) {
  if (status === 'Complete') {
    return (
      <Button
        size="small"
        variant="outlined"
        color="inherit"
        onClick={onView}
        sx={{
          ...TASK_BUTTON_SX,
          bgcolor: '#fff',
          borderColor: 'rgba(0,0,0,0.23)',
          color: 'text.primary',
          '&:hover': {
            borderColor: 'rgba(0,0,0,0.45)',
            bgcolor: 'rgba(0,0,0,0.02)',
          },
        }}
      >
        View
      </Button>
    );
  }

  return (
    <Button
      size="small"
      variant="contained"
      color="warning"
      onClick={onComplete}
      sx={TASK_BUTTON_SX}
    >
      Complete Now
    </Button>
  );
}

export function ChildHeaderRow({ name, colSpan }: { name: string; colSpan: number }) {
  return (
    <TableRow>
      <TableCell
        colSpan={colSpan}
        sx={{
          bgcolor: 'rgba(25, 118, 210, 0.06)',
          fontWeight: 700,
          borderBottom: '1px solid rgba(0,0,0,0.06)',
        }}
      >
        {name}
      </TableCell>
    </TableRow>
  );
}

export function EventHeaderRow({ name, colSpan }: { name: string; colSpan: number }) {
  return (
    <TableRow>
      <TableCell
        colSpan={colSpan}
        sx={{
          bgcolor: 'rgba(0,0,0,0.02)',
          color: 'text.secondary',
          fontWeight: 600,
          borderBottom: '1px solid rgba(0,0,0,0.06)',
        }}
      >
        {name}
      </TableCell>
    </TableRow>
  );
}

export function WaiverActionButton({
  status,
  onComplete,
  onView,
}: {
  status: TaskStatus;
  onComplete?: () => void;
  onView?: () => void;
}) {
  if (status === 'Complete') {
    return (
      <Button
        size="small"
        variant="outlined"
        color="inherit"
        onClick={onView}
        sx={{
          ...TASK_BUTTON_SX,
          bgcolor: '#fff',
          borderColor: 'rgba(0,0,0,0.23)',
          color: 'text.primary',
          '&:hover': {
            borderColor: 'rgba(0,0,0,0.45)',
            bgcolor: 'rgba(0,0,0,0.02)',
          },
        }}
      >
        View
      </Button>
    );
  }

  return (
    <Button
      size="small"
      variant="contained"
      color="warning"
      onClick={onComplete}
      sx={TASK_BUTTON_SX}
    >
      Complete Now
    </Button>
  );
}
